import { format, parseISO, isValid } from 'date-fns';

export function formatDate(isoString, fallback = '—') {
  if (!isoString) return fallback;
  try {
    const date = typeof isoString === 'string' ? parseISO(isoString) : isoString;
    return isValid(date) ? format(date, 'MMM d, yyyy') : fallback;
  } catch {
    return fallback;
  }
}

export function formatDateTime(isoString, fallback = '—') {
  if (!isoString) return fallback;
  try {
    const date = typeof isoString === 'string' ? parseISO(isoString) : isoString;
    return isValid(date) ? format(date, 'MMM d, yyyy HH:mm') : fallback;
  } catch {
    return fallback;
  }
}

export function formatTime(isoString, fallback = '—') {
  if (!isoString) return fallback;
  try {
    const date = typeof isoString === 'string' ? parseISO(isoString) : isoString;
    return isValid(date) ? format(date, 'HH:mm') : fallback;
  } catch {
    return fallback;
  }
}